<template>

      <div class="components_warp">
        <div class="top-container">
          <div v-for="(topic, index) in topics" :key="index">
            <div v-if="index == curIndex">
              <div class="top-content">
                <div class="img-box">
                  <img :src="topic.img" alt="">
                </div>
              </div>
              <div class="radio-list">
                <section class="light">
                  <label v-for="(t, index) in topic.options" :key="index">
                    <input class="radio_btn" type="radio" name="light" v-model="radioVal" :value="t.optOrder" />
                    <span class="design"></span>
                    <span class="text">
                      <img :src="t.optImg" alt="">
                    </span>
                  </label>
                </section>
              </div>
            </div>
          </div>
        </div>
        <div class="btn_warp">
          <!-- <button><router-link to="/yuyanbiaodadati">确定</router-link></button> -->
          <span></span>
          <button @click="next">确定</button>
          <span
            ><em>{{ curIndex + 1 }}</em
            >/{{ topics.length }}</span
          >
        </div>
      </div>


</template>

<script>
export default {
  data() {
    return {
      curIndex: 0,
      topics: [],
      answers:[],
      startTime:'',
      endTime:'',
      tempTime:'',
      radioVal:'',
      url:{path:'/careerevalution/home',query: { name:'znsp',part:'znsp61'}}
    };
  },
  created() {
    this.getTopicApi();
  },
  mounted(){
    this.startTime = new Date().getTime();
  },
  methods: {
    getTopicApi() {
      this.$ajax
        .post(
          `${this.G_capi}${this.ports.careerEvaluation.znsp.sxnlList3}`,
          {},
          {
            headers: {
              token: sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.topics = res.data.data;
          console.log(this.topics);
        });
    },
    next() {

      if(this.radioVal == ""){
        this.$message.error('请选择答案')
        return false
      }
      this.answers.push({
        questionId:this.topics[this.curIndex].id,
        answer:this.radioVal
      })

      this.radioVal = ""

      if (this.curIndex + 1 < this.topics.length) {
        this.curIndex++;
      } else {
        this.saveNode(2,61,()=>{
          this.submit()
        })
      }
    },
    submit(){ //提交
      this.endTime = new Date().getTime();//结束时间
      this.tempTime = Number(this.endTime) - Number(this.startTime);
      this.$ajax.post(`${this.G_capi}${this.ports.careerEvaluation.znsp.sxnlAdd3}`,{
          testId:sessionStorage.getItem('testId'),
          time:this.tempTime,
          answers:this.answers,
      },{
            headers:{
              token:sessionStorage.getItem('token')
            }
        })
        .then((res) => {
            var data = res.data;
            if(data.code==2000){
              this.$router.push({
                path: "/careerevalution/success",
                query: {
                  type: "answer",
                  url:this.url,
                },
              });
            }
        })
    },
  },
};
</script>

<style scoped>
.components_warp{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.title h4 {
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
.btn_warp {
  /* width: 70%;
    text-align: center;
    position: absolute;
    bottom:70px; */
  display: flex;
  justify-content: space-between;
}
/* 按钮 */
.btn_warp button {
  width: 166px;
  height: 41px;
  background: linear-gradient(90deg, #1fd99c 0%, #1ac6fd 100%);
  border-radius: 21px;
  border: none;
  color: #fff;
  font-size: 18px;
  margin: 40px auto 0;
  display: block;
}

.btn_warp em {
  font-style: normal;
  color: red;
}
.btn_warp span {
    font-size: 18px;
  /* position: relative;
    right: -250px; */
  display: block;
  flex: 1;
  text-align: right;
  margin-top: 40px;
  line-height: 41px;
}
.top-content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-box {
  width: 300px;
  height: 200px;
  /* border: 1px solid red; */
}
.img-box img{
  width: 100%;
}

/* 单选按钮 */

.light {
  --primary: #29d3ec;
  --other: #29d3ec;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.dark {
  --primary: hsl(1, 100%, 68%);
  --other: hsl(0, 0%, 90%);
  background: hsl(0, 0%, 10%);
}

/* h1 */
h1 {
  color: var(--other);
  padding: 8px 4px;
  border-bottom: 2px solid var(--other);
}

/* label */
label {
  width: 200px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  margin: 12px 0;
  cursor: pointer;
  position: relative;
  border-radius: 8px;
}

/* input */
.radio_btn {
  opacity: 0;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: -1;
}

/* .design */
.design {
  width: 16px;
  height: 16px;
  border: 1px solid var(--other);
  border-radius: 100%;
  margin-right: 16px;
  position: relative;
}

.design::before,
.design::after {
  content: "";
  display: block;

  width: inherit;
  height: inherit;

  border-radius: inherit;

  position: absolute;
  -webkit-transform: scale(0);
  transform: scale(0);
  -webkit-transform-origin: center center;
  transform-origin: center center;
}

.design:before {
  background: var(--other);
  opacity: 0;
  transition: 0.3s;
}

.design::after {
  background: var(--primary);
  opacity: 0.4;
  transition: 0.6s;
}

/* .text */
.text {
  display: inline-block;
  color: #333;
  width: 110px;
  height: 80px;
  /* border: 1px solid red; */
  /* font-weight: bold; */
}
.text img{
  width: 100%;
}

/* checked state */
.radio_btn:checked + .design::before {
  opacity: 1;
  -webkit-transform: scale(0.6);
  transform: scale(0.6);
}

.time {
  position: absolute;
  top: 32px;
  right: 40px;
  color: red;
}
</style>